import { RootState } from "../../../redux-store";
import { createSelector } from "@reduxjs/toolkit";

const selectCargosTimeTracking = (state: RootState) =>
  state.app.cargoTimeTracking;

export const selectCargoStartTrackingInProgress = (cargoId: string) =>
  createSelector(
    selectCargosTimeTracking,
    (cargosTimeTracking) =>
      !!cargosTimeTracking.cargoTimeTrackingRequestsInProgress[cargoId]?.start
  );

export const selectCargoPauseResumeTrackingInProgress = (cargoId: string) =>
  createSelector(selectCargosTimeTracking, (cargosTimeTracking) => {
    const c = cargosTimeTracking.cargoTimeTrackingRequestsInProgress[cargoId];
    return !!c?.pause || !!c?.resume;
  });

export const selectCargoStopTrackingInProgress = (cargoId: string) =>
  createSelector(
    selectCargosTimeTracking,
    (cargosTimeTracking) =>
      !!cargosTimeTracking.cargoTimeTrackingRequestsInProgress[cargoId]?.stop
  );
